import React from 'react';
import { Box, useModal, Alert } from '@zen-common/components-base';
import { useUnmountedRef } from '@zen/common-react-hooks';
import { NamingAssetStore } from '@zen/common-app-parts';
import usePreventAction from '../../utils/usePreventAction';
import { RedeemStore } from '../../stores/FixedPayoutStore';
import FPLayout from '../../components/layouts/FPLayout';
import RedeemForm from './RedeemForm';
import RedeemNotifications from './RedeemNotifications';
import RedeemResult from './RedeemResult';

export default function Redeem() {
  const unmounted = useUnmountedRef();
  const { show, hide } = useModal();
  const { preventAction } = usePreventAction();
  const store = RedeemStore.useStore();
  const { state: naming } = NamingAssetStore.useStore();
  const handleSubmit = async (e) => {
    e && e.preventDefault && e.preventDefault();

    if (preventAction()) return;

    try {
      await store.actions.generate();
      if (!unmounted.current) {
        show(() => <RedeemResult />);
      }
    } catch (error) {
      if (!unmounted.current) {
        show(() => (
          <Alert type={Alert.TYPE.ERROR} onDismiss={hide} title="Error">
            {error.message}
          </Alert>
        ));
      }
    }
  };

  return (
    <FPLayout title="Redeem a position token using the fixed payout contract">
      <Box maxWidth="formsMaxWidth">
        <RedeemForm onSubmit={handleSubmit} store={store} naming={naming} />
      </Box>
      <RedeemNotifications />
    </FPLayout>
  );
}
